import { useTranslation } from "react-i18next";

import { Card } from "~/components/ui";

export function CategorySchemaMigrationSupportScope() {
  const { t } = useTranslation();

  return (
    <Card className="space-y-3">
      <div>
        <div className="text-12-medium text-fg-2">{t("feature.categories.recordMigration.supportScopeTitle")}</div>
        <div className="mt-1 text-12-regular text-fg-3">
          {t("feature.categories.recordMigration.supportScopeDescription")}
        </div>
      </div>
      <div className="grid gap-2 sm:grid-cols-3">
        <div className="rounded-[var(--radius-sm)] border border-border-default px-3 py-2">
          <div className="text-12-medium text-success">
            {t("feature.categories.recordMigration.supportedChangesLabel")}
          </div>
          <div className="mt-1 text-12-regular text-fg-3">
            {t("feature.categories.recordMigration.supportedChangesDescription")}
          </div>
        </div>
        <div className="rounded-[var(--radius-sm)] border border-border-default px-3 py-2">
          <div className="text-12-medium text-fg-2">{t("feature.categories.recordMigration.manualChangesLabel")}</div>
          <div className="mt-1 text-12-regular text-fg-3">
            {t("feature.categories.recordMigration.manualChangesDescription")}
          </div>
        </div>
        <div className="rounded-[var(--radius-sm)] border border-border-default px-3 py-2">
          <div className="text-12-medium text-fg-2">
            {t("feature.categories.recordMigration.noMigrationIntentChangesLabel")}
          </div>
          <div className="mt-1 text-12-regular text-fg-3">
            {t("feature.categories.recordMigration.noMigrationIntentChangesDescription")}
          </div>
        </div>
      </div>
    </Card>
  );
}
